module.exports = __webpack_public_path__ + "img/blog-other-articles-img-1.ffebba29.png";